import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { 
  Home, ArrowUpCircle, ArrowDownCircle, History, User, Settings, 
  Shield, LogOut, Bell, TrendingUp, Wallet, CheckCircle, Star,
  MessageSquare, Send, Clock, Check, CheckCheck
} from "lucide-react";

// Browser Frame Component (Bybit dark theme)
const BrowserFrame = () => (
  <div className="flex-shrink-0" style={{ backgroundColor: '#202124' }}>
    <div className="flex items-center h-[38px]" style={{ backgroundColor: '#202124' }}>
      <div className="flex items-end flex-1 pl-2">
        <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: '#35363a' }}>
          <img src="/ozon-favicon.ico" alt="" className="w-4 h-4 mr-2 flex-shrink-0" />
          <span className="text-[13px] truncate flex-1" style={{ color: '#9aa0a6' }}>Ozon Карта</span>
        </div>
        <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px] cursor-pointer" style={{ backgroundColor: '#0d0d1a' }}>
          <span className="text-[13px] truncate flex-1" style={{ color: '#e8eaed' }}>Трейдинг P2P</span>
        </div>
        <button className="w-7 h-7 flex items-center justify-center rounded-full ml-1 mb-1" style={{ color: '#9aa0a6' }}>
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        </button>
      </div>
      <div className="flex items-center h-full">
        <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#3c3d41]" style={{ color: '#9aa0a6' }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
        <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#3c3d41]" style={{ color: '#9aa0a6' }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
        <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: '#9aa0a6' }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
      </div>
    </div>
    <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: '#292a2d' }}>
      <div className="flex items-center gap-1 mr-2">
        <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: '#9aa0a6' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
        <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: '#5f6368' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>
        <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: '#9aa0a6' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg></button>
      </div>
      <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: '#202124', border: '1px solid #3c4043' }}>
        <svg className="w-4 h-4 mr-3 flex-shrink-0" style={{ color: '#9aa0a6' }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
        <span className="text-[14px]" style={{ color: '#e8eaed' }}>treider2p.com/trades</span>
      </div>
      <div className="flex items-center gap-1 ml-3">
        <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: '#9aa0a6' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></button>
        <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: '#9aa0a6' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>
      </div>
    </div>
  </div>
);

export default function BybitTrades() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [showBrowser, setShowBrowser] = useState(true);

  // Set body background for Bybit theme
  useEffect(() => {
    const rootEl = document.getElementById('root');
    document.documentElement.classList.add('bybit-theme');
    document.body.classList.add('bybit-theme');
    document.body.style.cssText = 'margin: 0; padding: 0; background-color: #1a1a2e; min-height: 100vh;';
    document.documentElement.style.cssText = 'background-color: #1a1a2e; min-height: 100vh;';
    if (rootEl) {
      rootEl.classList.add('bybit-theme');
      rootEl.style.cssText = 'min-height: 100vh; background-color: #1a1a2e;';
    }
    return () => {
      document.documentElement.classList.remove('bybit-theme');
      document.body.classList.remove('bybit-theme');
      document.body.style.cssText = '';
      document.documentElement.style.cssText = '';
      if (rootEl) {
        rootEl.classList.remove('bybit-theme');
        rootEl.style.cssText = '';
      }
    };
  }, []);

  useEffect(() => {
    // Check URL params
    const browserParam = searchParams.get('showBrowser');
    const storageKey = searchParams.get('storageKey');
    const dataParam = searchParams.get('data');
    
    if (browserParam !== null) {
      setShowBrowser(browserParam !== 'false');
    }
    
    let parsed = null;
    
    // Priority 1: Try data from URL (for archive screenshots)
    if (dataParam) {
      try {
        parsed = JSON.parse(decodeURIComponent(dataParam));
        if (parsed.showBrowser !== undefined) {
          setShowBrowser(parsed.showBrowser);
        }
      } catch (e) {
        console.error("Error parsing URL data:", e);
      }
    }
    
    // Priority 2: Try storageKey
    if (!parsed && storageKey) {
      try {
        const stored = localStorage.getItem(storageKey);
        if (stored) {
          parsed = JSON.parse(stored);
          if (parsed.showBrowser !== undefined) {
            setShowBrowser(parsed.showBrowser);
          }
        }
      } catch (e) {
        console.error("Error parsing storageKey data:", e);
      }
    }
    
    // Priority 3: Try standard localStorage key
    if (!parsed) {
      try {
        const stored = localStorage.getItem('bybit_preview_data');
        if (stored) {
          parsed = JSON.parse(stored);
          if (parsed.showBrowser !== undefined) {
            setShowBrowser(parsed.showBrowser);
          }
        }
      } catch (e) {
        console.error("Error parsing localStorage data:", e);
      }
    }
    
    if (parsed) {
      setData(parsed);
      if (parsed.trades?.length > 0) {
        setSelectedTrade(parsed.trades[0]);
      }
    }
  }, [searchParams]);

  if (!data) {
    return (
      <div className="min-h-screen bg-[#0d0d1a] flex items-center justify-center">
        <div className="text-white text-lg">Загрузка...</div>
      </div>
    );
  }

  const menuItems = [
    { icon: Home, label: 'Главная' },
    { icon: TrendingUp, label: 'P2P Торговля', active: true },
    { icon: Wallet, label: 'Кошелёк' },
    { icon: History, label: 'История' },
    { icon: MessageSquare, label: 'Сообщения' },
    { icon: User, label: 'Профиль' },
    { icon: Shield, label: 'Безопасность' },
    { icon: Settings, label: 'Настройки' },
  ];

  const getPartnerInitials = (name) => {
    if (!name) return 'TR';
    return name.split(/[_\s]/).map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="h-screen bg-[#0d0d1a] flex flex-col" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {showBrowser && <BrowserFrame />}
      <div className="flex flex-1 min-h-0">
      {/* Sidebar */}
      <aside className="w-64 bg-[#1a1a2e] flex flex-col border-r border-gray-800 flex-shrink-0">
        <div className="p-5 border-b border-gray-800">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-white font-bold text-xl">P2P Exchange</h1>
              <p className="text-gray-500 text-xs">Crypto Trading</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-4">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={index}
                className={`w-full flex items-center gap-3 px-5 py-3 text-sm transition-all ${
                  item.active 
                    ? 'bg-amber-500/10 text-amber-400 border-r-2 border-amber-400' 
                    : 'text-gray-400 hover:bg-white/5 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-800">
          <button className="w-full flex items-center gap-3 px-4 py-2.5 text-gray-400 hover:text-white hover:bg-white/5 rounded-lg">
            <LogOut className="w-5 h-5" />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-0 bg-[#0d0d1a]">
        {/* Header */}
        <header className="flex-shrink-0 bg-[#1a1a2e] border-b border-gray-800 px-6 py-4 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white">P2P Сделки</h2>
            <p className="text-gray-500 text-sm">История успешных обменов</p>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-green-500/10 border border-green-500/30 rounded-full">
              <CheckCircle className="w-4 h-4 text-green-400" />
              <span className="text-green-400 text-sm font-medium">Верифицирован</span>
            </div>
            
            <div className="flex items-center gap-3 pl-4 border-l border-gray-700">
              <div className="w-9 h-9 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-bold">
                  {data.firstName?.[0]}{data.lastName?.[0]}
                </span>
              </div>
              <div>
                <p className="text-sm font-medium text-white">{data.fullName}</p>
                <p className="text-xs text-gray-500">@{data.username}</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 flex overflow-hidden">
          {/* Trades List */}
          <div className="w-80 bg-[#1a1a2e] border-r border-gray-800 flex flex-col">
            <div className="p-4 border-b border-gray-800">
              <h3 className="text-white font-medium">Завершённые сделки</h3>
              <p className="text-gray-500 text-sm">{data.trades?.length || 0} успешных</p>
            </div>
            <div className="flex-1 overflow-y-auto">
              {(data.trades || []).map((trade, index) => (
                <button
                  key={trade.id || index}
                  onClick={() => setSelectedTrade(trade)}
                  className={`w-full p-4 text-left border-b border-gray-800 hover:bg-white/5 transition-colors ${
                    selectedTrade?.id === trade.id ? 'bg-amber-500/10 border-l-2 border-l-amber-400' : ''
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-medium text-sm">
                      {getPartnerInitials(trade.partnerName)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between">
                        <p className="text-white font-medium truncate">{trade.partnerName}</p>
                        <span className="text-green-400 text-xs flex items-center gap-1">
                          <CheckCircle className="w-3 h-3" /> Успешно
                        </span>
                      </div>
                      <div className="flex items-center justify-between mt-1">
                        <p className="text-amber-400 text-sm font-medium">{parseInt(trade.amount).toLocaleString()} ₽</p>
                        <p className="text-gray-500 text-xs">{trade.crypto}</p>
                      </div>
                      <p className="text-gray-500 text-xs mt-1">{trade.date}</p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Chat Area */}
          <div className="flex-1 flex flex-col bg-[#0d0d1a]">
            {selectedTrade ? (
              <>
                {/* Chat Header */}
                <div className="p-4 bg-[#1a1a2e] border-b border-gray-800 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-medium">
                      {getPartnerInitials(selectedTrade.partnerName)}
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <p className="text-white font-medium">{selectedTrade.partnerName}</p>
                        <span className="flex items-center gap-1 text-amber-400 text-xs">
                          <Star className="w-3 h-3 fill-current" /> 4.8
                        </span>
                      </div>
                      <p className="text-gray-500 text-sm">Сделка на {parseInt(selectedTrade.amount).toLocaleString()} ₽ • {selectedTrade.crypto}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="px-3 py-1 bg-green-500/10 text-green-400 text-sm rounded-full flex items-center gap-1">
                      <CheckCircle className="w-4 h-4" />
                      Сделка завершена
                    </span>
                  </div>
                </div>

                {/* Messages */}
                <div className="flex-1 overflow-y-auto p-4 space-y-4">
                  {/* Trade Info */}
                  <div className="flex justify-center">
                    <div className="px-4 py-2 bg-[#1a1a2e] rounded-full text-gray-400 text-sm">
                      Сделка открыта • {selectedTrade.date}
                    </div>
                  </div>

                  {(selectedTrade.messages || []).map((msg, index) => (
                    <div
                      key={index}
                      className={`flex ${msg.from === 'me' ? 'justify-end' : 'justify-start'}`}
                    >
                      <div className={`max-w-[70%] ${msg.from === 'me' ? 'order-2' : ''}`}>
                        {msg.from !== 'me' && (
                          <div className="flex items-center gap-2 mb-1">
                            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-xs">
                              {getPartnerInitials(selectedTrade.partnerName)}
                            </div>
                            <span className="text-gray-500 text-xs">{selectedTrade.partnerName}</span>
                          </div>
                        )}
                        <div
                          className={`px-4 py-3 rounded-2xl ${
                            msg.from === 'me'
                              ? 'bg-amber-500 text-white rounded-br-md'
                              : 'bg-[#1a1a2e] text-white rounded-bl-md'
                          }`}
                        >
                          <p className="text-sm">{msg.text}</p>
                        </div>
                        <div className={`flex items-center gap-1 mt-1 ${msg.from === 'me' ? 'justify-end' : ''}`}>
                          <span className="text-gray-600 text-xs">
                            {new Date(Date.now() - (selectedTrade.messages.length - index) * 60000 * Math.random() * 10).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
                          </span>
                          {msg.from === 'me' && (
                            <CheckCheck className="w-3 h-3 text-amber-400" />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Trade completed */}
                  <div className="flex justify-center">
                    <div className="px-4 py-2 bg-green-500/10 border border-green-500/30 rounded-full text-green-400 text-sm flex items-center gap-2">
                      <CheckCircle className="w-4 h-4" />
                      Сделка успешно завершена
                    </div>
                  </div>
                </div>

                {/* Input Area (disabled) */}
                <div className="p-4 bg-[#1a1a2e] border-t border-gray-800">
                  <div className="flex items-center gap-3 px-4 py-3 bg-[#0d0d1a] rounded-xl opacity-50">
                    <input
                      type="text"
                      placeholder="Сделка завершена"
                      disabled
                      className="flex-1 bg-transparent text-gray-500 text-sm outline-none"
                    />
                    <button disabled className="p-2 text-gray-600">
                      <Send className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex-1 flex items-center justify-center">
                <div className="text-center">
                  <MessageSquare className="w-16 h-16 text-gray-700 mx-auto mb-4" />
                  <p className="text-gray-500">Выберите сделку для просмотра переписки</p>
                </div>
              </div>
            )}
          </div>
        </main>
        </div>
      </div>
    </div>
  );
}
